// Thin wrappers around GA4 gtag. gtag() itself is defined inline in
// public/index.html (so window.gtag always exists by the time React mounts);
// these helpers just guard against the static pre-render pass and a missing tag.

export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || window.__PRERENDER__) return;
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
};

// Primary conversion: clicking through to the Discord invite. `source` tells us
// which page/section drove it (home, join-page, squadrons-hub, squadron, footer)
// and `extra` can carry e.g. { squadron: '<slug>' } so we can see which squadron
// page actually converts. Mark `join_discord` as a Key event in GA4 → Admin →
// Events for it to count as a conversion.
export const trackJoinDiscord = (source, extra = {}) =>
  trackEvent('join_discord', Object.assign({ source_page: source }, extra));
